import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useDialogOpenedContext } from '@sorare/core/src/contexts/dialogOpened';
import { useSnackNotificationContext } from '@sorare/core/src/contexts/snackNotification';
import { useTimeoutFn } from '@sorare/core/src/hooks/animations/useTimeoutFn';
import { useIsMobileApp } from '@sorare/core/src/hooks/useIsMobileApp';

const DIALOG_OPEN_GRACE_PERIOD_MS = 2000;

export const usePackOpeningInterruptedSnackbar = () => {
  const { currentUser } = useCurrentUserContext();
  const { isIosApp } = useIsMobileApp();

  const { showNotification } = useSnackNotificationContext();

  const { isDialogOpen } = useDialogOpenedContext();

  const shouldShowToast =
    !isIosApp && !!currentUser?.claimablePacks.length && !isDialogOpen;

  // A reveal dialog registers in DialogOpenedContext one tick after claimablePacks
  // populates, so isDialogOpen is briefly false while a pack opening is starting. The
  // delay lets the dialog open and cancel this toast before it fires.
  useTimeoutFn(
    () => showNotification('packOpeningInterruptedCardsPending'),
    shouldShowToast ? DIALOG_OPEN_GRACE_PERIOD_MS : null
  );

  return null;
};
